export const HOME_PASSINGS_REQUEST = 'HOME_PASSINGS_REQUEST';
export const HOME_PASSINGS_ERROR = 'HOME_PASSINGS_ERROR';
export const HOME_PASSINGS_LOADED = 'HOME_PASSINGS_LOADED';
export const HOME_PASSINGS_SET_ACTIVE = 'HOME_PASSINGS_SET_ACTIVE';
export const HOME_PASSINGS_NEW_REQUEST = 'HOME_PASSINGS_NEW_REQUEST';
export const HOME_PASSINGS_NEW_LOADED = 'HOME_PASSINGS_NEW_LOADED';
export const HOME_PASSINGS_NEW_ERROR = 'HOME_PASSINGS_NEW_ERROR';
